@if (logado()) {
  <div class="usuario-logado">
    <span class="usuario-logado-avatar" aria-hidden="true">
      <i-lucide name="user" size="20"></i-lucide>
    </span>

    <p class="usuario-logado-saudacao">Olá, {{ identificacao() }}</p>

    @if (mostrarAcessoArea()) {
      <a class="usuario-logado-acessar" [routerLink]="linkMinhaArea()">Acessar minha área</a>
    }

    <button type="button" class="usuario-logado-sair" (click)="sair()">Sair</button>
  </div>
}
